<template>
	<el-dialog :title="title" :close-on-click-modal='false' :visible.sync="dialogVisible" width="50%"
		:before-close="handleClose" append-to-body>
		<el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="120px" class="demo-ruleForm">
			<el-form-item label="所属产品" prop="productID">
				<el-select placeholder="请选择" filterable v-model="ruleForm.productID">
					<el-option v-for="item in productList" :label="item.name" :value="item.id">
					</el-option>
				</el-select>
			</el-form-item>
			<el-form-item label="资源分类名称" prop="name">
				<el-input v-model="ruleForm.name"></el-input>
			</el-form-item>
		</el-form>
		<span slot="footer" class="dialog-footer">
			<el-button type="primary" @click="submitForm('ruleForm')">立即{{type==='add'?'添加':'修改'}}</el-button>
			<el-button @click="resetForm('ruleForm')">重置</el-button>
		</span>
	</el-dialog>
</template>

<script>
	export default {
		name: 'schoolEdit',
		props: {
			type: {
				type: String,
				default: 'add'
			},
			title: {
				type: String
			},
			dialogVisible: {
				type: Boolean,
				default: false
			},
			productList: {
				type: Array
			},
			obj: {
				type: Object,
				default: null
			}
		},
		data() {
			return {
				ruleForm: {
					id: '',
					productID: '',
					name: '',

				},
				rules: {
					name: [{
						required: true,
						message: '请输入资源分类名称',
						trigger: 'blur'
					}],
					productID: [{
						required: true,
						message: '请选择所属产品',
						trigger: 'change'
					}]
				}
			}
		},
		watch: {
			obj(val) {
				this.ruleForm = JSON.parse(JSON.stringify(val))
			}
		},
		methods: {
			submitForm(formName) {
				this.$refs[formName].validate((valid) => {
					if (valid) {
						this.type === 'add' && this.$http.post('api/productResource/SaveResourceType', this
							.ruleForm).then(res => {
							if (res.data.code == 1) {
								this.handleClose()
							} else {
								this.$message({
									message: res.data.message,
									type: 'error'
								})
							}
						})

						this.type === 'update' && this.$http.post('api/productResource/EditResourceType', this
							.ruleForm).then(
							res => {
								if (res.data.code == 1) {
									this.handleClose()
								} else {
									this.$message({
										message: res.data.message,
										type: 'error'
									})
								}
							})
					} else {
						console.log('error submit!!');
						return false;
					}
				});
			},
			resetForm(formName) {
				this.$refs[formName].resetFields();
			},
			handleClose() {
				this.$emit('before-close')
			}
		}
	}
</script>
